/**
 * AgentPanelWrapper — Renders FloatingDock + AiAssistantPanel when authenticated.
 *
 * The FloatingDock replaces the old separate AgentTriggerButton,
 * unifying phone + AI into a single gorgeous dock.
 */
import { useState } from 'react'
import { useIsAuthenticated, useUser } from '@/stores/authStore'
import { AiAssistantPanel } from './AiAssistantPanel'
import { FloatingDock } from './FloatingDock'

export function AgentPanelWrapper() {
  const isAuthenticated = useIsAuthenticated()
  const user = useUser()
  const [isOpen, setIsOpen] = useState(false)

  if (!isAuthenticated || !user) return null

  return (
    <>
      <FloatingDock isAiOpen={isOpen} onToggleAi={setIsOpen} />
      <AiAssistantPanel
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        userRole={user.role || 'viewer'}
        companyId={user.company_id || ''}
        permissions={user.permissions || []}
      />
    </>
  )
}
